import * as React from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import { BookingExtendedView } from 'cb-model';
import { useCacheQuery } from 'gossamer-front-end';
import { QueryOptions } from 'gossamer-unified';
import { BookedEventTile, EventTile, formatEventUrl, formatSingleDate } from 'shared-front-end';

export const BookingList = ({ query, emptyText }: { query: QueryOptions; emptyText: string }) => {
  const bookings = useCacheQuery(BookingExtendedView, query);

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '1rem',
      }}
    >
      {bookings.isFetching && <Spinner animation="border" />}
      {bookings.error && <Alert variant="danger">Unable to load bookings.</Alert>}
      {!bookings.isFetching && !bookings.error && !bookings.data?.length && <Alert variant="light">{emptyText}</Alert>}
      {bookings.data?.map((item) => (
        <BookedEventTile
          key={item.ticket_booking_id}
          eventId={item.event_id}
          eventType={item.type}
          title={item.title}
          image={item.images}
          plainDescription={item.plain_description}
          markdownDescription={item.markdown_description || undefined}
          startAt={item.start_at}
          flowOption={item.flow_option}
          ticketBookingId={item.ticket_booking_id}
          attendanceResult={item.attendance_result}
          hasLeftFeedback={!!item.event_feedback_id}
        />
      ))}
    </div>
  );
};

export const EventList = ({ query, emptyText }: { query: QueryOptions; emptyText: string }) => {
  const bookings = useCacheQuery(BookingExtendedView, query);

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '1rem',
      }}
    >
      {bookings.isFetching && <Spinner animation="border" />}
      {bookings.error && <Alert variant="danger">Unable to load bookings.</Alert>}
      {!bookings.isFetching && !bookings.error && !bookings.data?.length && <Alert variant="light">{emptyText}</Alert>}
      {bookings.data?.map((item) => (
        <EventTile
          key={item.ticket_booking_id}
          eventUrl={formatEventUrl(item.title || '', item.event_id)}
          eventType={item.type}
          title={item.title}
          image={item.images}
          plainDescription={item.plain_description}
          markdownDescription={item.markdown_description || undefined}
          startDate={formatSingleDate(new Date(item.start_at), true)}
        />
      ))}
    </div>
  );
};
